import React, { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle, ArrowRight, Star, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
	const { user } = useAuth();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const sessionId = searchParams.get("session_id");
	const [redirecting, setRedirecting] = useState(!!sessionId);

	useEffect(() => {
		if (!user) {
			navigate("/");
			return;
		}
		if (!sessionId) return;

		// After Stripe success with session_id → take user to report generation page
		const t = setTimeout(() => {
			navigate(`/report-generation?session_id=${sessionId}`, { replace: true });
		}, 2000);
		return () => clearTimeout(t);
	}, [user, navigate, sessionId]);

	if (!user) return null;

	return (
		<div className="min-h-screen bg-gradient-to-br from-indigo-900 via-purple-900 to-black flex items-center justify-center p-4">
			<div className="max-w-md w-full bg-white/10 backdrop-blur-lg rounded-2xl p-8 shadow-2xl border border-white/20 text-center animate-in fade-in zoom-in duration-500">
				<div className="mb-6 relative inline-block">
					<div className="absolute inset-0 bg-green-500 blur-xl opacity-50 rounded-full animate-pulse"></div>
					<CheckCircle className="w-20 h-20 text-green-400 relative z-10 mx-auto" />
				</div>

				<h1 className="text-3xl font-bold text-white mb-2">Payment Successful!</h1>
				<p className="text-purple-200 mb-8">
					{sessionId
						? "Thank you for your purchase. Taking you to your report..."
						: "Thank you for your purchase. Your cosmic journey has been unlocked."}
				</p>

				{sessionId ? (
					<div className="flex flex-col items-center gap-4 mb-8">
						<Loader2 className="w-10 h-10 text-purple-400 animate-spin" />
						<p className="text-gray-300 text-sm">Preparing your report page...</p>
					</div>
				) : (
					<div className="bg-white/5 rounded-xl p-6 mb-8 border border-white/10">
						<div className="flex items-center justify-center gap-2 text-yellow-400 mb-2">
							<Star className="w-5 h-5 fill-yellow-400" />
							<span className="font-semibold tracking-wide uppercase text-sm">Premium Access</span>
							<Star className="w-5 h-5 fill-yellow-400" />
						</div>
						<p className="text-gray-300 text-sm">
							You now have access to advanced heliocentric charts and detailed reports.
						</p>
					</div>
				)}

				{!redirecting && (
					<button
						onClick={() => navigate("/app")}
						className="w-full group flex items-center justify-center gap-2 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-300 shadow-lg hover:shadow-purple-500/25 transform hover:-translate-y-0.5"
					>
						Go to Dashboard
						<ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
					</button>
				)}
				{sessionId && (
					<button
						onClick={() => navigate(`/report-generation?session_id=${sessionId}`, { replace: true })}
						className="text-sm text-purple-300 hover:text-white mt-4"
					>
						Go to report now
					</button>
				)}
			</div>
		</div>
	);
}
